import React from 'react';

const Loader = () => (
	<div id="loader">
		<div id="loader-holder">
	        <div id="loader-text">Loading Handwriting</div>
	    </div>
	</div>
);

export default Loader;



// WEBPACK FOOTER //
// ./src/components/global/Loader.js